const ReviewEditItem = ({
  navItemLabelId = "",
  navItemBtnId = "",
  navItemLabelText = "",
  editToggle = () => {},
}) => {
  return (
    <div className="row">
      <div className="col-6" id={navItemLabelId}>
        <span>{navItemLabelText}</span>
      </div>
      <div className="col-6">
        <span role="presentation" id="review-edit-btn" onClick={editToggle}>
          <strong id={navItemBtnId}>Review/Edit </strong>
          <span className="icon-xs icon-caret-spin-right"></span>
        </span>
      </div>
    </div>
  );
};

export default ReviewEditItem;
